<template>
  <div class="w-full lg:flex lg:flex-row">
    <div class="w-full py-10 lg:w-1/2">
      <div class="seccion w-full px-10">
        <div class="flex justify-between font-bold text-xs py-2  border-gray-200 border-b">
          <div class=" uppercase">Paso 2 de 3</div>
          <div class="red text-red-600">Ayuda</div>
        </div>
      </div>
      <div class="seccion w-full px-10 pt-3">
        <div v-if="direccionActual">
          <div v-if="condicional">
            <div class="text-green-500">
              Localidad válida
            </div>

          </div>
          <div v-else>
            <div class="text text-red-600 font-semibold">
              Establecimientos en Araba solamente
            </div>
          </div>

        </div>
        <h2 class="text-2xl text-left font-bold tracking-tight">Encuentra tu comercio</h2>
      </div>
      <div class="seccion w-full px-10 pt-3 ">
        <gmap-autocomplete
          :componentRestrictions='restricciones'
          language="es_ES"
          @place_changed="setActual"
        >
        </gmap-autocomplete>
      </div>
      <div class="seccion w-full px-10 pt-3 ">
        <div class="px-5 mt-5 text-left">
          <div> Introduce dirección, código postal y/o localidad para mejorar la búsqueda </div>
          <div class="py-3 bg-gray-100 border-gray-300 border-t border-b italic mt-5 pl-2 cursor-pointer hover:shadow-md hover:bg-gray-200">

            <div>
              <button @click="alta">
    
              No encuentra su comercio? pulse aquí

              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="seccion w-full pt-5 shadow-sm lg:hidden">
        <div class="w-full border-t border-b border-gray-200 py-3">
          <div class="text-sm text-red-700 font-bold flex justify-center">
            <button
              @click="verMapa = !verMapa"
              class="flex justify-center"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                class="icon-location-pin h-5 w-5"
              >
                <g>
                  <path
                    class="secondary"
                    d="M12 1v6a3 3 0 0 0 0 6v9.31a1 1 0 0 1-.7-.29l-5.66-5.66A9 9 0 0 1 12 1z"
                  />
                  <path
                    class="primary"
                    d="M12 1a9 9 0 0 1 6.36 15.36l-5.65 5.66a1 1 0 0 1-.71.3V13a3 3 0 0 0 0-6V1z"
                  />
                </g>
              </svg>
              {{verMapa ? 'Ocultar mapa' : 'Ver mapa' }}
            </button>
          </div>
        </div>
      </div>
      <div
        v-if="actual"
        class="w-full seccion px-10 py-5"
      >

        <div class="text-left">
          <h1 class="font-semibold uppercase">{{actual.name}} </h1>
          <div class="w-full h-1 border-gray-300 border-b shadow-sm mb-2">

          </div>
          <div class="px-3">
            {{actual.formatted_address}}
          </div>
        </div>
        <!-- <div
          v-if="actual.photos"
          class="w-full flex flex-wrap -mx-3"
        >
          <div
            v-for="(foto,f) in actual.photos"
            :key="f"
            class="w-32 h-32 mx-3 bg-cover bg-top bg-no-repeat"
            :style="`background-image:url('${foto.getUrl()}')`"
          >

          </div>
        </div> -->

      </div>
      <div>

      </div>
      <div
        v-if="actual"
        class="seccion flex w-full px-10 py-2 text-right flex-row justify-end"
      >
        <div class="w-1/2">
          <button
            :disabled="!condicional"
            :class="`${!condicional ? 'bg-gray-300': 'bg-red-600 hover:bg-red-700 ' } ` "
            class="rounded  px-5 py-2 text-white font-bold shadow-xs hover:shadow-md"
            @click="alta"
          > {{!condicional ? 'Comercio no válido' : 'Continuar' }} </button>
        </div>
      </div>
      <!-- <div class="seccion w-full px-10 pt-3 ">
        <div class="px-5 mt-5 text-left"> 
          <div> Introduce dirección, código postal y/o localidad para mejorar la búsqueda </div>
          <div class="py-3 bg-gray-100 border-gray-300 border-t border-b italic mt-5 pl-2 cursor-pointer hover:shadow-md hover:bg-gray-200">
             
             <router-link :to="`/${$i18n.locale}/altas`">
                No encuentras tu establecimiento? pulse aquí
             </router-link>
          </div>
        </div>    
      </div> -->

    </div>

    <div v-if="verMapa" class="lg:hidden">
      <GmapMap
        class="block"
        :center="centro"
        :zoom="zoom"
        style="width: 100%; height: 300px"
      >
        <gmap-info-window
          :options="infoOptions"
          :position="infoWindowPos"
          :opened="infoWinOpen"
          @closeclick="infoWinOpen=false"
        >
        </gmap-info-window>

        <GmapMarker
          :key="index"
          v-for="(m, index) in lista"
          :position="coordenadas(m)"
          :clickable="true"
          :draggable="false"
          :animation="2"
          @click="toggleInfoWindow(m,index)"
        />

      </GmapMap>
    </div>
    <div class="hidden lg:block lg:w-1/2 h-full bg-gray-400">
      <GmapMap
        :center="centro"
        :zoom="zoom"
        style="width: 100%; height:100vh"
      >
        <gmap-info-window
          :options="infoOptions"
          :position="infoWindowPos"
          :opened="infoWinOpen"
          @closeclick="infoWinOpen=false"
        >
        </gmap-info-window>

        <GmapMarker
          :key="index"
          v-for="(m, index) in lista"
          :position="coordenadas(m)"
          :clickable="true"
          :draggable="false"
          :animation="2"
          @click="toggleInfoWindow(m,index)"
        />

      </GmapMap>
    </div>
  </div>
</template>
<script>
export default {
  mounted() {
    // this.centro=this.coordenadas(this.items[0])
    this.localizar().then(posicion => {
      this.centro = posicion;
  // cl*("this.centro", posicion);
    });
  },
  watch: {
    items() {
  // cl*("cambio", this.items);
      this.zoom = 8;
    }
  },
  props: ["items"],
  data() {
    return {
      centro: { lat: 45.508, lng: -73.587 },
      zoom: 19,
      actual: null,
      verMapa: false,
      lista: [],
      localidadActual: "",
      busqueda: "",
      infoWindowPos: null,
      infoWinOpen: false,
      currentMidx: null,
      infoOptions: {
        content: "Contenido",
        //optional: offset infowindow so it visually sits nicely on top of our marker
        pixelOffset: {
          width: 0,
          height: -35
        }
      },
      restricciones: {
        country: "es"
      }
    };
  },
  computed: {
    direccionActual() {
      if (this.actual) {
        const establecimiento = this.actual;
        const direccion = {};
        establecimiento.address_components.map(
          e => (direccion[e.types[0]] = e.long_name)
        );
     /// console.log('direccion', direccion, establecimiento)
        this.$store.commit('direccionActual', direccion)
        return direccion;
      }
    },
    condicional() {
      if (this.direccionActual) {
        if (this.direccionActual.administrative_area_level_2 == "Araba") {
          return true;
        } else return false;
      }
    }
  },
  methods: {
    setActual(sitio) {
      this.actual = sitio;
      this.centro = this.coordenadas(sitio);
      if (sitio.hasOwnProperty("photos")) {
        this.actual.UrlImagen = sitio.photos[0].getUrl();
      }
  // cl*("setActual", sitio);
      this.lista.push(this.actual);
      const establecimiento = this.actual;
      const direccion = {};
      establecimiento.address_components.map(
        e => (direccion[e.types[0]] = e.long_name)
      );

      this.toggleInfoWindow(sitio, this.lista.length - 1);
    },
    alta() {
      if (this.actual.hasOwnProperty('geometry')) {
        const lat = this.actual.geometry.location.lat();
        const lng = this.actual.geometry.location.lng();
        const marker = {
          lat,
          lng
        };
    // cl*("existe?", this.actual, marker);
        // this.centro = this.marker
        // this.markers.push({ position: marker });
        const establecimiento = this.actual;
        const direccion = {};
        establecimiento.address_components.map(
          e => (direccion[e.types[0]] = e.long_name)
        );

        const datos = {};
        if (establecimiento.hasOwnProperty("photos")) {
          const imagen = establecimiento.photos[0].getUrl()
          datos.UrlImagen = imagen
          datos.UrlDni = imagen
          datos.UrlCertificado = imagen
          
        } else {
          datos.UrlImagen = "";
        }
        datos.Nombre = establecimiento.name;
        datos.Pais = direccion.country;
        datos.Descripcion = "Pruebas";
        datos.Telefono = establecimiento.formatted_phone_number;
        datos.CP = direccion.postal_code;
        datos.Lat = lat;
        datos.Lng = lng;
        datos.DireccionGoogle = establecimiento.formatted_address;
        datos.IdGoogle = establecimiento.place_id;
        datos.Direccion = direccion.route + " " + direccion.street_number;
        datos.Poblacion = direccion.locality;
        datos.Provincia = direccion.administrative_area_level_2;
        datos.Pais = direccion.country;
        datos.DireccionGoogle = establecimiento.formatted_address;
        datos.Web = establecimiento.website
        datos.SectorActividad = establecimiento.types[0]

        // this.$store.dispatch('alta',datos)

        this.$store.commit("establecimientoActual", datos);
        this.$router.push(`/${$i18n.locale}/comercios`);

        // <Peticion IdOrigen = "1" Nombre = "4" Descripcion="333333" CIF = "testo" Contacto = "testo" Telefono = "testo" EMail = "testo" Direccion = "testo" CP = "testo" Provincia = "testo" Poblacion = "testo" Pais = "testo" IBAN = "testo" IdGoogle = "testo" Lat = "testo" Lng = "testo" DireccionGoogle = "testo" UrlImagen = "testo" />

        this.lista.push(this.actual);
        this.actual = null;
      } else {

        const datos = {}
        datos.Lat = '1';
        datos.Lng = '1';
        datos.DireccionGoogle = '1';
        datos.IdGoogle = '1'
        datos.DireccionGoogle = '1';
        this.$store.commit("establecimientoActual", datos);
        this.$router.push("/altas");
      }
    },
    ver(actual) {
  // cl*("me", actual);
      this.zoom = 15;
    },
    toggleInfoWindow: function(marker, idx) {
  // cl*("toggleInfoWindow", marker, idx);
      this.infoWindowPos = this.coordenadas(marker);
      this.infoOptions.content = `<div class="max-w-xs">
      <div class="text-center px-3 pb-2 pt-2">
        <h3 class="text-black text-sm bold font-sans">${marker.name}</h3>
      </div>
    </div>`;

      //check if its the same marker that was selected if yes toggle
      if (this.currentMidx == idx) {
        this.infoWinOpen = !this.infoWinOpen;
      }
      //if different marker set infowindow to open and reset current marker index
      else {
        this.infoWinOpen = true;
        this.currentMidx = idx;
      }
    },
    coordenadas(actual) {
  // cl*("actual", actual);
      return {
        // lat: actual.geometry.coordinates[1],
        // lng: actual.geometry.coordinates[0]
        lat: actual.geometry.location.lat(),
        lng: actual.geometry.location.lng()
      };
    },
    localizar(options) {
      return this.$getLocation(options).then(coordinates => {
    // cl*("posicion", coordinates);
        if (coordinates) {
          {
            return coordinates;
          }
        }
      });
    }
  }
};
</script>
<style>
.secondary {
  fill: #f56565;
}
.primary {
  fill: #c53030;
}
.pac-target-input {
  width: 100%;
  padding: 4px 4px;
  padding-top: 4px;
  padding-right: 4px;
  padding-bottom: 4px;
  padding-left: 4px;
  border: 1px solid gainsboro;
  border-radius: 5px;
  margin: 2px;
}
</style>